/* eslint-disable import/no-anonymous-default-export */
import axios from './axios';

let URL = process.env.REACT_APP_PORTAL_URL;

export default {
  getRuns(params) {
    return axios.get(`${URL}/api/v1/runs`, { params });
  },
  getRun(id) {
    return axios.get(`${URL}/api/v1/runs/${id}`)
  },
  getRunJob(id) {
    return axios.get(`${URL}/api/v1/runs/${id}/job`)
  },
  getRunMetadata(id) {
    return axios.get(`${URL}/api/v1/runs/${id}/metadata`)
  },
  retryRun(id) {
    return axios.post(`${URL}/api/v1/runs/${id}/retry`)
  },
  stopRun(id) {
    return axios.patch(`${URL}/api/v1/runs/${id}`, {state: 'Stopping'})
  }
};
